import zod from 'zod';
import { stringToListOfNumber, zodLimit, zodPage } from './helpers';

export const DocumentsSchemas = {
    DocumentsList: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitIds: stringToListOfNumber.optional(),
        createdFrom: zod.coerce.number().optional(),
        createdTo: zod.coerce.number().optional(),
        userIds: stringToListOfNumber.optional(),
    }),
    DocumentCategories: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitIds: stringToListOfNumber.optional(),
    }),
};
